module.exports = __webpack_public_path__ + "static/media/alignLeft.867da3e6.svg";